import { useSelector } from 'react-redux';
import useShortCode from './useShortCode';
import useFetch from './useFetch';
import OrganisationService from '../services/organisation-service';
import { useLoadContext } from '../components/LoadBoundary';

const noop = async () => {};

function useOrganisation(shortCodeOverride, fetchOptions) {
  const stateShortCode = useShortCode();
  const ctx = useLoadContext();
  const { isLoggedIn } = useSelector(state => state.loginReducer);
  const shortCode = shortCodeOverride || stateShortCode;

  return (
    useFetch(isLoggedIn && shortCode ? OrganisationService.get : noop, shortCode, {
      throwOnError: !ctx.root,
      ...fetchOptions,
    }).data || {}
  );
}
export default useOrganisation;
